import {getStatusText as getRequestStatusText} from './requestStatuses';

const CATEGORY_META = {
    movement: {
        label: `Перемещения`,
        icon: `fas fa-route`,
        variant: `info`
    },
    receipt: {
        label: `Приходы`,
        icon: `fas fa-box-open`,
        variant: `success`
    },
    service: {
        label: `Ремонт и эксплуатация`,
        icon: `fas fa-tools`,
        variant: `warning`
    },
    changes: {
        label: `Изменения`,
        icon: `fas fa-pen`,
        variant: `secondary`
    },
    system: {
        label: `Системные`,
        icon: `fas fa-sync-alt`,
        variant: `dark`
    }
};

const ACTION_META = {
    created: [`Позиция создана`, `changes`, `fas fa-plus`],
    updated: [`Реквизиты изменены`, `changes`, `fas fa-pen`],
    archived: [`Позиция перемещена в архив`, `changes`, `fas fa-archive`],
    note_added: [`Добавлено примечание`, `changes`, `fas fa-sticky-note`],
    file_deleted: [`Файл удалён`, `changes`, `fas fa-file-minus`],
    primary_photo_changed: [`Изменено заглавное фото`, `changes`, `fas fa-image`],
    fuel_norm_created: [`Добавлена норма топлива`, `service`, `fas fa-gas-pump`],
    fuel_norm_updated: [`Изменена норма топлива`, `service`, `fas fa-gas-pump`],
    fuel_norm_deleted: [`Удалена норма топлива`, `service`, `fas fa-gas-pump`],
    meter_recorded: [`Зафиксировано показание счётчика`, `service`, `fas fa-tachometer-alt`],
    rented_out: [`Техника сдана в аренду`, `service`, `fas fa-handshake`],
    returned_from_rent: [`Техника возвращена из аренды`, `service`, `fas fa-undo`],
    request_repair_created: [`Создана заявка на ремонт`, `service`, `fas fa-tools`],
    request_repair_taken: [`Ремонт взят в работу`, `service`, `fas fa-wrench`],
    request_repair_cancelled: [`Ремонт отменён`, `service`, `fas fa-ban`],
    request_receipt: [`Позиция оприходована`, `receipt`, `fas fa-box-open`],
    request_quantity_shipment_adjusted: [`Остаток по заявке скорректирован`, `movement`, `fas fa-balance-scale`],
    request_issue_to_object: [`Техника выдана на объект`, `movement`, `fas fa-truck-loading`],
    request_move_to_object: [`Техника перемещена на объект`, `movement`, `fas fa-truck`],
    request_move_to_warehouse: [`Техника перемещена на склад`, `movement`, `fas fa-warehouse`],
    request_return_to_warehouse: [`Техника возвращена на склад`, `movement`, `fas fa-warehouse`],
    request_transfer_started: [`Техника отправлена`, `movement`, `fas fa-route`],
    request_transfer_updated: [`Маршрут перемещения изменён`, `movement`, `fas fa-route`],
    request_transfer_cancelled: [`Перемещение отменено`, `movement`, `fas fa-times-circle`],
    request_accept_to_repair: [`Техника принята в ремонт`, `service`, `fas fa-tools`],
    request_finish_repair: [`Ремонт техники завершён`, `service`, `fas fa-check`],
    request_rent_out: [`Техника сдана в аренду`, `service`, `fas fa-handshake`],
    request_return_from_rent: [`Техника возвращена из аренды`, `service`, `fas fa-undo`],
    import_1c_rb: [`Импортирована позиция 1С РБ`, `system`, `fas fa-file-import`],
    import_1c_rb_catalog_consolidated: [`Группа 1С РБ объединена`, `system`, `fas fa-object-group`],
    import_facekit_positions: [`Импортирована позиция FaceKIT`, `system`, `fas fa-file-import`],
    import_facekit_transfer: [`Импортировано перемещение FaceKIT`, `system`, `fas fa-exchange-alt`],
    import_facekit_creation: [`Импортировано создание из FaceKIT`, `system`, `fas fa-plus`],
    import_facekit_inventory: [`Импортирована инвентаризация FaceKIT`, `system`, `fas fa-clipboard-check`],
    import_facekit_spending: [`Импортировано списание FaceKIT`, `system`, `fas fa-minus-circle`],
    import_facekit_request: [`Импортирована заявка FaceKIT`, `system`, `fas fa-file-import`],
    import_facekit_transaction: [`Импортирована операция FaceKIT`, `system`, `fas fa-sync-alt`],
    demo_seed: [`Созданы демонстрационные данные`, `system`, `fas fa-vial`]
};

const LEGACY_FACEKIT_OBJECT_LABELS = {
    304: `Благовещенск. ШВЫ 2023`,
    395: `11. Талакан. СНГ. 32. Кап ремонт`,
    469: `21. Новокузнецк.АЭРОКУЗБАСС.ЕП 25_021.Ремонт`,
    472: `!База (офис) АДС, г. Домодедово (ДМД)`,
    481: `11. Бологое. Автобан. Фундаменты`,
    482: `30. Ульяновск.565.35-25.2025.Текущий ремонт`,
    483: `16. Сочи.МАС.293_26-МАС.Замена покрытий`,
    485: `19. Шереметьево.МАШ.1000052950.2026. Ремонт покрытий`,
    486: `23. Череповец. СаровГМ.1404-2026.Швы, кольматация`,
    489: `25. Красноярск.Емельяново. 2026.107482 Ремонт покрытий`,
    490: `21. Внуково.12706.2026.Замена плит`,
    300: `5. Краснодар. Аэропорт. Реконструкции РД-3`
};

const FIELD_LABELS = {
    catalog_id: `Группа техники`,
    display_name: `Название позиции`,
    status: `Статус`,
    technical_condition: `Состояние`,
    source_status: `Исходный статус`,
    location_type: `Тип местонахождения`,
    warehouse_id: `Склад`,
    building_process_id: `Объект`,
    object_group_id: `Группа объектов`,
    location_name: `Местонахождение`,
    responsible_user_id: `МОЛ`,
    accounting_company_name: `Компания-владелец`,
    owner_kind: `Тип владельца`,
    owner_name: `Владелец`,
    quantity: `Количество`,
    quantity_delta: `Изменение количества`,
    shipped_quantity: `Отгружено по заявке`,
    shipment_delta: `Изменение отгрузки`,
    accounting_type: `Способ учёта`,
    unit: `Единица измерения`,
    inventory_number: `Инвентарный номер`,
    serial_number: `Серийный номер`,
    vin: `VIN`,
    plate_number: `Госномер`,
    qr_code: `QR-код`,
    facekit_nomenclature_number: `Номер FaceKIT`,
    current_meter_type: `Тип счётчика`,
    current_meter_value: `Показание`,
    year_of_manufacture: `Год выпуска`,
    commissioned_at: `Введено в эксплуатацию`,
    accounting_cost: `Учётная стоимость`,
    cost_currency: `Валюта`,
    weight_kg: `Вес`,
    dimensions: `Габариты`,
    source_project_name: `Исходный проект`,
    source_warehouse_name: `Исходный склад`,
    source_responsible_name: `Исходный МОЛ`,
    comment: `Комментарий`,
    active_rental_id: `Аренда`,
    fuel_type_id: `Топливо`,
    work_type_id: `Группа работ`,
    primary_photo_file_id: `Заглавное фото`,
    deleted_file_name: `Файл`,
    value: `Значение нормы`,
    value_unit: `Единица нормы`,
    norm_type: `Тип нормы`,
    effective_from: `Действует с`,
    effective_to: `Действует до`,
    source: `Источник`,
    work_type_name: `Группа работ`,
    work_unit: `Единица работ`,
    is_approved: `Норма согласована`,
    approved_by: `Кто согласовал`,
    approved_at: `Дата согласования`,
    basis_document: `Документ-основание`,
    request_status: `Статус заявки`,
    facekit_warehouse: `Склад FaceKIT`,
    facekit_project: `Проект FaceKIT`,
    facekit_responsible: `МОЛ FaceKIT`,
    facekit_state: `Статус FaceKIT`,
    facekit_count: `Количество FaceKIT`
};

const INTERNAL_FIELDS = [
    `normalized_inventory_number`,
    `source_payload`,
    `facekit_transaction_id`,
    `facekit_transaction_type`,
    `facekit_transaction_status`,
    `facekit_src_building_process_id`,
    `facekit_dest_building_process_id`,
    `request_item_id`,
    `request_item_name`,
    `note_id`,
    `deleted_file_id`,
    `receipt`,
    `position_details`,
    `transfer_state`
];

export const MECHANIC_HISTORY_FILTERS = [
    {value: `all`, text: `Все`},
    {value: `movement`, text: CATEGORY_META.movement.label},
    {value: `receipt`, text: CATEGORY_META.receipt.label},
    {value: `service`, text: CATEGORY_META.service.label},
    {value: `changes`, text: CATEGORY_META.changes.label},
    {value: `system`, text: CATEGORY_META.system.label}
];

function hasOwn(value, key) {
    return Boolean(value && typeof value === `object` && Object.prototype.hasOwnProperty.call(value, key));
}

function hasValue(value) {
    return value !== null && value !== undefined && value !== ``;
}

function changeSide(change, side) {
    if (!hasOwn(change, `old`) && !hasOwn(change, `new`)) {
        return side === `new` ? change : null;
    }
    return change[side];
}

function formatNumber(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return hasValue(value) ? String(value) : null;
    }
    return numeric.toLocaleString(`ru-RU`, {maximumFractionDigits: 3});
}

function optionLabel(options, value, fallbackPrefix) {
    const rows = Array.isArray(options) ? options : [];
    const found = rows.find(option => String(option && option.value) === String(value));
    if (found) {
        return found.text;
    }
    return fallbackPrefix ? `${fallbackPrefix} ${value}` : String(value);
}

function formatDate(value) {
    if (!value) {
        return null;
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return String(value);
    }
    return date.toLocaleDateString(`ru-RU`);
}

function formatValue(key, value, context) {
    if (!hasValue(value)) {
        return null;
    }
    if (key === `status`) {
        return optionLabel(context.statusOptions, value);
    }
    if (key === `location_type`) {
        return optionLabel(context.locationTypeOptions, value);
    }
    if (key === `catalog_id`) {
        return optionLabel(context.catalogOptions, value, `Группа`);
    }
    if (key === `warehouse_id`) {
        return optionLabel(context.warehouseOptions, value, `Склад`);
    }
    if (key === `building_process_id`) {
        return optionLabel(context.objectOptions, value, `Объект`);
    }
    if (key === `object_group_id`) {
        return optionLabel(context.objectGroupOptions, value, `Группа объектов`);
    }
    if (key === `responsible_user_id`) {
        return optionLabel(context.userOptions, value, `Сотрудник`);
    }
    if (key === `request_status`) {
        return getRequestStatusText(value);
    }
    if (key === `accounting_type`) {
        return value === `quantity` ? `Количественный` : `Инвентарный`;
    }
    if ([`commissioned_at`, `effective_from`, `effective_to`, `approved_at`].includes(key)) {
        return formatDate(value);
    }
    if (key === `owner_kind`) {
        return value === `own` ? `Собственная` : (value === `rented` ? `Арендованная` : String(value));
    }
    if (typeof value === `boolean`) {
        return value ? `Да` : `Нет`;
    }
    if (typeof value === `object`) {
        return null;
    }
    return String(value);
}

function detailFromChange(key, change, context) {
    if (!hasOwn(change, `old`) && !hasOwn(change, `new`)) {
        const value = formatValue(key, change, context);
        return value ? {label: FIELD_LABELS[key] || humanizeFieldKey(key), value} : null;
    }
    const before = formatValue(key, change.old, context);
    const after = formatValue(key, change.new, context);
    if (!before && !after) {
        return null;
    }
    if (before === after) {
        return {label: FIELD_LABELS[key] || humanizeFieldKey(key), value: after || before};
    }
    return {
        label: FIELD_LABELS[key] || humanizeFieldKey(key),
        before,
        after
    };
}

function locationPointText(point, context) {
    if (!point || typeof point !== `object`) {
        return null;
    }
    if (point.object_group_name) return `Группа: ${point.object_group_name}`;
    if (point.object_group_id) return optionLabel(context.objectGroupOptions, point.object_group_id, `Группа объектов`);
    if (point.warehouse_name) {
        return point.warehouse_name;
    }
    if (point.object_name) {
        return point.object_name;
    }
    if (point.renter_name) {
        return point.renter_name;
    }
    if (point.warehouse_id) {
        return optionLabel(context.warehouseOptions, point.warehouse_id, `Склад`);
    }
    if (point.building_process_id) {
        return optionLabel(context.objectOptions, point.building_process_id, `Объект`);
    }
    const locationType = point.location_type || point.type;
    return point.location_label || (hasValue(locationType)
        ? optionLabel(context.locationTypeOptions, locationType)
        : null);
}

function locationFromChanges(changes, side, context) {
    const name = changeSide(changes.location_name, side);
    if (name) return name;
    const groupId = changeSide(changes.object_group_id, side);
    if (groupId) return optionLabel(context.objectGroupOptions, groupId, `Группа объектов`);
    const locationType = changeSide(changes.location_type, side);
    const warehouseId = changeSide(changes.warehouse_id, side);
    const objectId = changeSide(changes.building_process_id, side);
    if (warehouseId) {
        return optionLabel(context.warehouseOptions, warehouseId, `Склад`);
    }
    if (objectId) {
        return optionLabel(context.objectOptions, objectId, `Объект`);
    }
    return hasValue(locationType) ? optionLabel(context.locationTypeOptions, locationType) : null;
}

function transferRoute(changes, context) {
    const transferChange = changes.transfer_state;
    const transferCandidates = [
        changeSide(transferChange, `new`),
        changeSide(transferChange, `old`)
    ];
    for (const transfer of transferCandidates) {
        if (!transfer || typeof transfer !== `object`) {
            continue;
        }
        const from = locationPointText(transfer.from, context);
        const to = locationPointText(transfer.to, context);
        if (from || to) {
            return {from, to};
        }
    }
    const from = locationFromChanges(changes, `old`, context);
    const to = locationFromChanges(changes, `new`, context);
    return from || to ? {from, to} : null;
}

function genericDetails(changes, context, excludedFields) {
    const excluded = INTERNAL_FIELDS.concat(excludedFields || []);
    return Object.keys(changes || {})
        .filter(key => !excluded.includes(key))
        .map(key => detailFromChange(key, changes[key], context))
        .filter(Boolean);
}

function receiptPresentation(changes, context) {
    const delta = formatNumber(changes.quantity_delta);
    const unit = context.unit || ``;
    const quantity = changes.quantity || {};
    const before = formatNumber(changeSide(quantity, `old`));
    const after = formatNumber(changeSide(quantity, `new`));
    const receipt = changes.receipt && typeof changes.receipt === `object` ? changes.receipt : {};
    const location = locationFromChanges(changes, `new`, context);
    const details = [];
    if (before || after) {
        details.push({
            label: `Остаток`,
            before: before ? `${before}${unit ? ` ${unit}` : ``}` : null,
            after: after ? `${after}${unit ? ` ${unit}` : ``}` : null
        });
    }
    if (location) {
        details.push({label: `Куда оприходовано`, value: location});
    }
    if (hasValue(receipt.unit_cost)) {
        const cost = formatNumber(receipt.unit_cost);
        const total = formatNumber(receipt.total_cost);
        const currency = receipt.currency || ``;
        details.push({
            label: `Стоимость`,
            value: `${cost}${currency ? ` ${currency}` : ``} за единицу${total ? ` · всего ${total}${currency ? ` ${currency}` : ``}` : ``}`
        });
    }
    const positionDetails = changes.position_details && typeof changes.position_details === `object`
        ? changes.position_details
        : {};
    Object.keys(positionDetails).forEach(key => {
        const detail = detailFromChange(key, positionDetails[key], context);
        if (detail && detail.value) {
            details.push(detail);
        }
    });
    return {
        summary: delta
            ? `Оприходовано ${delta}${unit ? ` ${unit}` : ``}${location ? ` · ${location}` : ``}`
            : (location ? `Оприходовано · ${location}` : null),
        details: details.concat(genericDetails(changes, context, [
            `quantity`,
            `quantity_delta`,
            `location_type`,
            `warehouse_id`,
            `building_process_id`
        ]))
    };
}

function quantityShipmentPresentation(changes, context) {
    const shipmentDeltaValue = changeSide(changes.shipment_delta, `new`);
    const shipmentDelta = hasValue(shipmentDeltaValue) ? Number(shipmentDeltaValue) : null;
    const quantity = changes.quantity || {};
    const shippedQuantity = changes.shipped_quantity || {};
    const before = formatNumber(changeSide(quantity, `old`));
    const after = formatNumber(changeSide(quantity, `new`));
    const shippedBefore = formatNumber(changeSide(shippedQuantity, `old`));
    const shippedAfter = formatNumber(changeSide(shippedQuantity, `new`));
    const unit = context.unit || ``;
    const amount = Number.isFinite(shipmentDelta) ? formatNumber(Math.abs(shipmentDelta)) : null;
    const details = [];
    if (before || after) {
        details.push({
            label: `Остаток`,
            before: before ? `${before}${unit ? ` ${unit}` : ``}` : null,
            after: after ? `${after}${unit ? ` ${unit}` : ``}` : null
        });
    }
    if (shippedBefore || shippedAfter) {
        details.push({
            label: FIELD_LABELS.shipped_quantity,
            before: shippedBefore ? `${shippedBefore}${unit ? ` ${unit}` : ``}` : null,
            after: shippedAfter ? `${shippedAfter}${unit ? ` ${unit}` : ``}` : null
        });
    }
    const hasDirection = Number.isFinite(shipmentDelta);
    const isReturn = hasDirection && shipmentDelta < 0;
    return {
        title: hasDirection
            ? (isReturn ? `Количество возвращено в остаток` : `Количество списано по заявке`)
            : null,
        summary: amount
            ? `${amount}${unit ? ` ${unit}` : ``}${after ? ` · остаток ${after}${unit ? ` ${unit}` : ``}` : ``}`
            : null,
        details: details.concat(genericDetails(changes, context, [
            `quantity`,
            `quantity_delta`,
            `shipped_quantity`,
            `shipment_delta`
        ]))
    };
}

function meterPresentation(changes, context) {
    const value = changes.current_meter_value || changes.value;
    const type = changeSide(changes.current_meter_type, `new`) || context.meterType;
    const after = formatNumber(changeSide(value, `new`));
    return {
        summary: after ? `${after}${type ? ` · ${type}` : ``}` : null,
        details: genericDetails(changes, context)
    };
}

function facekitPresentation(changes, context) {
    const sourceId = changes.facekit_src_building_process_id && changes.facekit_src_building_process_id.new;
    const targetId = changes.facekit_dest_building_process_id && changes.facekit_dest_building_process_id.new;
    const from = sourceId
        ? (LEGACY_FACEKIT_OBJECT_LABELS[Number(sourceId)] || optionLabel(context.objectOptions, sourceId, `Объект`))
        : null;
    const to = targetId
        ? (LEGACY_FACEKIT_OBJECT_LABELS[Number(targetId)] || optionLabel(context.objectOptions, targetId, `Объект`))
        : null;
    const details = genericDetails(changes, context);
    return {
        summary: from || to ? [from, to].filter(Boolean).join(` → `) : null,
        route: from || to ? {from, to} : null,
        details
    };
}

function actionPresentation(row, context) {
    const changes = row.changes && typeof row.changes === `object` ? row.changes : {};
    if (row.action === `request_receipt`) {
        return receiptPresentation(changes, context);
    }
    if (row.action === `request_quantity_shipment_adjusted`) {
        return quantityShipmentPresentation(changes, context);
    }
    if (row.action === `meter_recorded`) {
        return meterPresentation(changes, context);
    }
    if (String(row.action || ``).indexOf(`import_facekit_`) === 0) {
        return facekitPresentation(changes, context);
    }
    if (row.action === `created`) {
        const details = genericDetails(changes, context).map(detail => {
            if (!detail.before && detail.after) {
                return {label: detail.label, value: detail.after};
            }
            return detail;
        });
        const nameDetail = details.find(detail => detail.label === FIELD_LABELS.display_name);
        const location = locationFromChanges(changes, `new`, context);
        return {
            summary: [nameDetail && nameDetail.value, location].filter(Boolean).join(` · `) || null,
            details
        };
    }
    const action = String(row.action || ``);
    const canShowRoute = action === `updated` ||
        action === `rented_out` ||
        action === `returned_from_rent` ||
        action.indexOf(`request_`) === 0;
    const route = canShowRoute ? transferRoute(changes, context) : null;
    const details = genericDetails(changes, context, route ? [
        `location_name`,
        `object_group_id`,
        `location_type`,
        `warehouse_id`,
        `building_process_id`
    ] : []);
    return {
        summary: route && (route.from || route.to)
            ? [route.from, route.to].filter(Boolean).join(` → `)
            : null,
        route,
        details
    };
}

function fallbackActionTitle(action) {
    return action ? `Событие «${action}»` : `Событие`;
}

function humanizeFieldKey(key) {
    return String(key || `Поле`)
        .replace(/_/g, ` `)
        .replace(/^./, value => value.toUpperCase());
}

export function presentMechanicAssetHistoryRow(row, context = {}) {
    const safeRow = row || {};
    const metaSource = ACTION_META[safeRow.action] || [fallbackActionTitle(safeRow.action), `system`, `fas fa-history`];
    const category = metaSource[1];
    const presentation = actionPresentation(safeRow, context);
    const actorId = safeRow.changed_by || null;
    return {
        id: safeRow.id,
        action: safeRow.action,
        title: presentation.title || metaSource[0],
        category,
        categoryLabel: CATEGORY_META[category].label,
        variant: CATEGORY_META[category].variant,
        icon: metaSource[2] || CATEGORY_META[category].icon,
        createdAt: safeRow.created_at,
        actor: safeRow.ChangedBy || null,
        actorId,
        actorName: safeRow.changed_by_name || (actorId ? `Сотрудник #${actorId}` : `Система`),
        requestId: safeRow.request_id || null,
        requestNumber: safeRow.request_number || null,
        requestTitle: safeRow.request_title || null,
        comment: safeRow.comment || null,
        summary: presentation.summary,
        route: presentation.route || null,
        details: presentation.details || [],
        raw: safeRow
    };
}

export function presentMechanicAssetHistory(rows, context = {}) {
    return (Array.isArray(rows) ? rows : []).map(row => presentMechanicAssetHistoryRow(row, context));
}
